<template>
    <page :busy="busy" :tabs="tabs" :compact-mobile-view="true">
        <grid
            ref="grid"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :treeData="false"
            :getDataPath="getDataPath"
            :isExternalFilterPresent="isExternalFilterPresent"
            :doesExternalFilterPass="doesExternalFilterPass"
            :rowData="categories"
        >
            <responsive-button
                :icon="['fas', 'plus']"
                modal="create-partner-category-modal"
                variant="primary"
                >
                Create partner category
            </responsive-button>
            <CreateCategoryModal
                @startCreating="modalCreateClicked"
                @endCreating="modalEndCreate"
            />
        </grid>
    </page>
</template>


<script>
import API from '../../../.././api';
import Page from '../../../generic/page/page.vue';
import Grid from '../../../generic/grid/grid.vue';
import ActionsCellRenderer from './actions-cell-renderer.vue';
import ResponsiveButton from '../../../generic/responsive-button/responsive-button.vue';
import CreateCategoryModal from './create-partner-category-modal.vue';


export default {
    name: 'PartnerAdminCategory',
    components: {
        Page,
        Grid,
        ResponsiveButton,
        CreateCategoryModal,
        actionsCellRenderer: ActionsCellRenderer,
    },
    data() {
        return {
            tabs: [
                {
                    title: 'Partner card categories',
                    route: '/app/partner-cards/admin/',
                    active: true,
                },
                {
                    title: 'Partner card data',
                    route: '/app/partner-cards/admin/card-data/',
                    active: false,
                },
                {
                    title: 'Partner card tooltips',
                    route: '/app/partner-cards/admin/card-tooltips/',
                    active: false,
                },
            ],
            busy: false,
            categories: [],
            defaultColDef: {
                minWidth: 80,
                sortable: true
            },
            getDataPath: data => data.id,
        };
    },
    computed: {
        columnDefs() {
            return [
                {
                    field: 'id',
                    headerName: 'Category ID',
                    flex: 1,
                    minWidth: 150,
                    editable: false,
                },
                {
                    type: 'editableColumn',
                    field: 'name',
                    headerName: 'Category Name',
                    sort: 'asc',
                    flex: 3,
                    minWidth: 150,
                    editable: ({ data }) => !data.deleted,
                    valueSetter: ({ oldValue, newValue, node, data }) => {
                        (async () => {
                            try {
                                await API.put(
                                    `/app/partner-cards/category/${data.id}/`,
                                    {
                                        name: newValue,
                                    }
                                );
                                const message = 'Name has been updated to ' + newValue;
                                this.successToast({text: message})
                            } catch (error) {
                                this.errorToast({text: 'Could not save category name.'})
                                data.name = oldValue;
                                node.setData(data);
                            }
                        })();
                        data.name = newValue;
                        return true;
                    },
                },
                {
                    headerName: 'Number of Partners',
                    valueGetter: ({ data }) => data.partners.length,
                    minWidth: 200
                },
                {
                    type: 'switchColumn',
                    field: 'deleted',
                    headerName: 'Enable',
                    valueGetter: ({ data }) => !data.deleted,
                    cellRendererParams: {
                        msgOn: "Are you sure you want to enable this category? Partners categorized under this category will be shown at partners page.",
                        msgOff: "Are you sure you want to disable this category? Partners categorized under this category will not be shown at partners page.",
                        onChange: async ({ node, api }, newValue) => {
                            const row = node.data;
                            const disabled = !newValue;
                            this.busy = true;
                            try {
                                await API.put(
                                    `/app/partner-cards/category/${row.id}/`,
                                    {
                                        deleted: disabled,
                                        name: row.name,
                                    }
                                );
                                var message =
                                    'Partner category successfully ' +
                                    (disabled ? 'disabled.' : 'enabled.');
                                this.successToast({text: message})
                            } catch (error) {
                                this.busy = false;
                                this.errorToast({text: 'Could not disable category'})
                            }
                            const updateRows = [row];
                            const updateNodes = [node];
                            row.deleted = disabled;
                            api.applyTransaction({ update: updateRows });
                            api.redrawRows({ rowNodes: updateNodes });
                            this.busy = false;
                        },
                    },
                },
                {
                    headerName: '',
                    minWidth: 190,
                    resizable: false,
                    cellStyle: {textAlign: "center"},
                    cellRenderer: 'actionsCellRenderer',
                },
            ];
        },
        isExternalFilterPresent() {
            return () => false;
        },
        doesExternalFilterPass() {
            return node => !node.data.deleted;
        },
    },

    mounted() {
        (async () => {
            this.busy = true;
            await this.fetchCategories();
            this.busy = false;
        })();
    },

    beforeCreate() {
        document.body.className = 'lx-partner-card-categories-admin';
    },
    methods: {
        async fetchCategories() {
            try {
                this.busy = true;
                const response = await API.get('/app/partner-cards/category/');
                this.categories = response.data;
            } catch (err) {
                this.errorToast({text: 'Could not load category data.'})
                this.busy = false;
            }
        },
        modalCreateClicked() {
            this.busy = true;
        },
        async modalEndCreate() {
           await this.fetchCategories();
           this.busy = false;
        }
    },
};
</script>


<style lang="scss">
    body.lx-partner-card-categories-admin {
        overflow: hidden;
    }
</style>
